export default __webpack_public_path__ + "static/partner-logos-baaf93c095e231c01c34342f75dafe63.png";